import axios from "axios"

export default function api() {}

api.connectOffline = async (user, pass) => {
  if (user === "fi-remote" && pass === "(KiWi)mgu[369]remote") return {token: "success", name: "remote", owner: "FI", _id: "1"}
  console.log("check failed")
  return false
}


api.connect = async (user, pass) => {
  console.log("api connecting login", { uname: user, passw: pass }, window.fmsApiLink)
  return await axios.create({ baseURL: window.fmsApiLink }).post("users/login", { uname: user, passw: pass })
}
/*
api.connect = async (user, pass) => {
  return await api.call.post("users/login", { uname: user, passw: pass })
}*/

api.authCheck = async () => {
  const apiToken = localStorage.getItem('apiToken')
  return await axios.create({ baseURL: window.fmsApiLink }).get('users/me', { headers: { "Authorization" : `Bearer ${apiToken}` }})
}

api.generateSonaeMission = async (data) => { // expects: { robotId: "our-robot-id", orderCode: "sonae-order-code"}
  const apiToken = localStorage.getItem('apiToken')
  // console.log("api calling", data)
  return await axios.create({ baseURL: window.fmsApiLink }).post("circuit/run", data, {
    headers: { Authorization: `Bearer ${apiToken}` },
  })
}

api.saveCircuit = async (circuit) => {
  const apiToken = localStorage.getItem('apiToken')
  // console.log("api token", apiToken)
  return await axios.create({ baseURL: window.fmsApiLink }).post("circuit/new", circuit, {
    headers: { Authorization: `Bearer ${apiToken}` },
  })
}

api.saveMap = async (map) => {
  const apiToken = localStorage.getItem('apiToken')
  // console.log("api save map", map, id)
    return await axios.create({ baseURL: window.fmsApiLink }).post("map/new", map, {
      headers: { Authorization: `Bearer ${apiToken}` },
    })
}

api.base64SizeKB = (base64 = '') => (base64.length * 0.75) / 1024

// Converte canvas para base64 com redução opcional de tamanho
api.canvasToBase64 = (canvas, options = {}) => {
  try {
    const {
      maxWidth = 1600,
      maxHeight = 900,
      maxSizeKB = 350,
      quality = 0.8,
      minQuality = 0.35,
      qualityStep = 0.08,
      resizeStep = 0.85,
      minWidth = 480,
      minHeight = 270,
      mimeType = 'image/jpeg'
    } = options

    const sourceWidth = canvas.width
    const sourceHeight = canvas.height

    let targetWidth = sourceWidth
    let targetHeight = sourceHeight

    const widthRatio = maxWidth / sourceWidth
    const heightRatio = maxHeight / sourceHeight
    const ratio = Math.min(widthRatio, heightRatio, 1)

    if (ratio < 1) {
      targetWidth = Math.round(sourceWidth * ratio)
      targetHeight = Math.round(sourceHeight * ratio)
    }

    const exportCanvas = document.createElement('canvas')
    exportCanvas.width = targetWidth
    exportCanvas.height = targetHeight

    const exportContext = exportCanvas.getContext('2d')
    exportContext.drawImage(canvas, 0, 0, targetWidth, targetHeight)

    let currentQuality = quality
    let currentWidth = targetWidth
    let currentHeight = targetHeight
    let base64 = exportCanvas.toDataURL(mimeType, currentQuality)

    while (api.base64SizeKB(base64) > maxSizeKB) {
      if (mimeType === 'image/jpeg' && currentQuality > minQuality) {
        currentQuality = Math.max(minQuality, Number((currentQuality - qualityStep).toFixed(2)))
      } else {
        const nextWidth = Math.max(minWidth, Math.round(currentWidth * resizeStep))
        const nextHeight = Math.max(minHeight, Math.round(currentHeight * resizeStep))

        if (nextWidth === currentWidth && nextHeight === currentHeight) {
          break
        }

        currentWidth = nextWidth
        currentHeight = nextHeight
        exportCanvas.width = currentWidth
        exportCanvas.height = currentHeight
        exportContext.drawImage(canvas, 0, 0, currentWidth, currentHeight)
        currentQuality = quality
      }

      base64 = exportCanvas.toDataURL(mimeType, currentQuality)
    }

    const sizeKB = api.base64SizeKB(base64).toFixed(2)
    
    console.log(`Canvas capturado: ${sourceWidth}x${sourceHeight} -> ${currentWidth}x${currentHeight}, qualidade: ${currentQuality}, tamanho: ${sizeKB}KB`)
    
    return base64
  } catch (error) {
    console.error('Erro ao converter canvas para base64:', error)
    throw error
  }
}

/*
api.createMap = async map => {
  const apiToken = localStorage.getItem('apiToken')
  console.log("creating map", map, window.settings.fmsIp)
  const res = await axios.create({ baseURL: window.fmsApiLink }).post('map/new', map, { headers: { Authorization: `Bearer ${apiToken}`, } })
  return res
}*/

api.sendTrigger = async (trigger) => {
  const apiToken = localStorage.getItem('apiToken')
  // console.log("api save map", map, id)
  return await axios.create({ baseURL: window.fmsApiLink }).post("triggers/new", trigger, {
    headers: { Authorization: `Bearer ${apiToken}` },
  })
}

api.fetchTriggers = async (filters) => {
  const apiToken = localStorage.getItem('apiToken')
  //const query = { query: filters }
  return await axios.create({ baseURL: window.fmsApiLink }).post("triggers/fetch", filters, {
    headers: { Authorization: `Bearer ${apiToken}` },
  }).catch(e => console.log("catched error", e))
}

api.cancelTriggers = async (id) => {
  const apiToken = localStorage.getItem('apiToken')
  const res = await axios.create({ baseURL: window.fmsApiLink }).put("triggers/" + id, {processed: true} , {
    headers: { Authorization: `Bearer ${apiToken}`, }
  }).catch(e => console.log("catched error", e))
  return res
}

api.updateMap = async map => {
  const apiToken = localStorage.getItem('apiToken')
  // console.log("api updating fms map", map)
  const res = await axios.create({ baseURL: window.fmsApiLink }).put('map/' + map._id, map, { headers: { Authorization: `Bearer ${apiToken}`, } })
  return res
}



api.getRobotInfo = async robotName => {
  const apiToken = localStorage.getItem('apiToken')
   console.log("api token", apiToken, robotName)
  const res = await axios.create({ baseURL: window.fmsApiLink }).post('robots', { name: robotName }, { headers: { Authorization: `Bearer ${apiToken}`, } })
  console.log("fms robot info", res)
  return res
}

api.updateAreaMap = async (areaId, mapId) => {
  const apiToken = localStorage.getItem('apiToken')
  // console.log("updating area map", areaId, mapId)
  const res = await axios.create({ baseURL: window.fmsApiLink }).put('area/' + String(areaId), { mapId: mapId }, { headers: { Authorization: `Bearer ${apiToken}`, } })
  return res
}

api.getMap = async mapName => {
  const apiToken = localStorage.getItem('apiToken')
  // console.log("api getting map info", mapName)
  const res = await axios.create({ baseURL: window.fmsApiLink }).post('map/', { name: mapName }, { headers: { Authorization: `Bearer ${apiToken}`, } })
  return res
}

api.fetchMaps = async (query) => {
  let apiToken
  if (localStorage.getItem("apiToken")[0] !== '"') apiToken = localStorage.getItem("apiToken")
  else apiToken = localStorage.getItem('apiToken')
  return await axios.create({ baseURL: window.fmsApiLink }).post("map", query, {
    headers: { Authorization: `Bearer ${apiToken}` },
  }).catch(e => console.log("catched error", e))
}

api.fetchOrders = async (filters) => {
  const apiToken = localStorage.getItem('apiToken')
  const query = { query: filters, limit: 10 }
  // return await axios.create({ baseURL: window.fmsApiLink }).post("orders/fetch", query, {
  return await axios.create({ baseURL: window.fmsApiLink }).post("orders", query, {
    headers: { Authorization: `Bearer ${apiToken}` },
  }).catch(e => console.log("caught error", e))
}

api.cancelOrders = async (id) => {
  const apiToken = localStorage.getItem('apiToken')
  const res = await axios.create({ baseURL: window.fmsApiLink }).put("orders/" + id, { cancelled: true }, {
    headers: { Authorization: `Bearer ${apiToken}`, }
  }).catch(e => console.log("catched error", e))
  return res
}

api.designations = async (filters) => {
  const apiToken = JSON.parse(localStorage.getItem('apiToken'))
  const query = { query: filters, limit: 100 }
  return await axios.create({ baseURL: window.fmsApiLink }).post("designations", query, {
    headers: { Authorization: `Bearer ${apiToken}` },
  }).catch(e => console.log("catched error", e))
}

api.distributions = async (filters) => {
  const apiToken = JSON.parse(localStorage.getItem('apiToken'))
  const query = { query: filters, limit: 100 }
  return await axios.create({ baseURL: window.fmsApiLink }).post("distributions", query, {
    headers: { Authorization: `Bearer ${apiToken}` },
  }).catch(e => console.log("catched error", e))
}

api.saveDistributions = async (distributions) => {
  const apiToken = JSON.parse(localStorage.getItem('apiToken'))
  return await axios.create({ baseURL: window.fmsApiLink }).post("/distributions/new", distributions, {
    headers: { Authorization: `Bearer ${apiToken}` },
  })
}

api.startDistributions = async (query) => {
  const apiToken = JSON.parse(localStorage.getItem('apiToken'))
  return await axios.create({ baseURL: window.fmsApiLink }).post("/distributions/start", query, {
    headers: { Authorization: `Bearer ${apiToken}` },
  })
}

api.collectDistributions = async (query) => {
  const apiToken = JSON.parse(localStorage.getItem('apiToken'))
  return await axios.create({ baseURL: window.fmsApiLink }).post("/distributions/collect", query, {
    headers: { Authorization: `Bearer ${apiToken}` },
  })
}

api.returns = async (filters) => {
  const apiToken = JSON.parse(localStorage.getItem('apiToken'))
  const query = { query: filters, limit: 100 }
  return await axios.create({ baseURL: window.fmsApiLink }).post("returns", query, {
    headers: { Authorization: `Bearer ${apiToken}` },
  }).catch(e => console.log("catched error", e))
}

api.saveReturns = async (returns) => {
  const apiToken = JSON.parse(localStorage.getItem('apiToken'))
  return await axios.create({ baseURL: window.fmsApiLink }).post("/returns/new", returns, {
    headers: { Authorization: `Bearer ${apiToken}` },
  })
}

api.startReturns = async (query) => {
  const apiToken = JSON.parse(localStorage.getItem('apiToken'))
  return await axios.create({ baseURL: window.fmsApiLink }).post("/returns/start", query, {
    headers: { Authorization: `Bearer ${apiToken}` },
  })
}

api.collectReturns = async (query) => {
  const apiToken = JSON.parse(localStorage.getItem('apiToken'))
  return await axios.create({ baseURL: window.fmsApiLink }).post("/returns/collect", query, {
    headers: { Authorization: `Bearer ${apiToken}` },
  })
}

api.fetchMissions = async (query) => {
  const apiToken = JSON.parse(localStorage.getItem('apiToken'))
  return await axios.create({ baseURL: window.fmsApiLink }).post("missions", query, {
    headers: { Authorization: `Bearer ${apiToken}` },
  })
}

api.startOrder = async (query) => {
  const apiToken = JSON.parse(localStorage.getItem('apiToken'))
  return await axios.create({ baseURL: window.fmsApiLink }).post("orders/new", query, {
    headers: { Authorization: `Bearer ${apiToken}` },
  })
}

api.cancelAllOrders = async (query) => {
  const apiToken = localStorage.getItem('apiToken')
  
  return await axios.create({ baseURL: window.fmsApiLink }).post("orders/cancel", query, {
    headers: { Authorization: `Bearer ${apiToken}` },
  })
}

api.processAllTriggers = async () => {
  const apiToken = JSON.parse(localStorage.getItem('apiToken'))
  return await axios.create({ baseURL: window.fmsApiLink }).post("triggers/process", {}, {
    headers: { Authorization: `Bearer ${apiToken}` },
  })
}

api.findUsed = async (query) => {
  const apiToken = JSON.parse(localStorage.getItem('apiToken'))
  return await axios.create({ baseURL: window.fmsApiLink }).post("used", query, {
    headers: { Authorization: `Bearer ${apiToken}` },
  })
}

api.updateUsed = async (query, type) => {
  const apiToken = JSON.parse(localStorage.getItem('apiToken'))
  return await axios.create({ baseURL: window.fmsApiLink }).post("/used/update/" + type, query, {
    headers: { Authorization: `Bearer ${apiToken}` },
  })
}

api.deleteUsed = async (type) => {
  const apiToken = JSON.parse(localStorage.getItem('apiToken'))
  return await axios.create({ baseURL: window.fmsApiLink }).delete("/used/delete/" + type, {
    headers: { Authorization: `Bearer ${apiToken}` },
  })
}

api.removeUsed = async (type, position) => {
  let apiToken
  if (localStorage.getItem("apiToken")[0] !== '"') apiToken = localStorage.getItem("apiToken")
  else apiToken = JSON.parse(localStorage.getItem('apiToken'))
  return await axios.create({ baseURL: window.fmsApiLink }).put("/used/remove/" + type, position, {
    headers: { Authorization: `Bearer ${apiToken}` },
  })
}

api.fetchOperations = async (query) => {
  const apiToken = JSON.parse(localStorage.getItem('apiToken'))
  return await axios.create({ baseURL: window.fmsApiLink }).post("operations", query, {
    headers: { Authorization: `Bearer ${apiToken}` },
  })
}

api.fetchJourney = async () => {
  const apiToken = JSON.parse(localStorage.getItem('apiToken'))
  return await axios.create({ baseURL: window.fmsApiLink }).post('journey', { headers: { Authorization: `Bearer ${apiToken}` } })
}

api.saveJourney = async (journey) => {
  const apiToken = JSON.parse(localStorage.getItem('apiToken'))
  return await axios.create({ baseURL: window.fmsApiLink }).post("/journey/new/", journey, {
    headers: { Authorization: `Bearer ${apiToken}` }
  }).catch(e => console.log("caught error", e))
}

api.deleteTasks = async (mapId) => {
  const apiToken = localStorage.getItem('apiToken')
  return await axios.create({ baseURL: window.fmsApiLink }).delete("task/map/" + mapId, {
    headers: { Authorization: `Bearer ${apiToken}` },
  }).catch(e => console.log("catched error", e))
}

api.saveTask = async (task) => {
  const apiToken = localStorage.getItem('apiToken')
  return await axios.create({ baseURL: window.fmsApiLink }).post("task/new", task, {
    headers: { Authorization: `Bearer ${apiToken}` },
  }).catch(e => console.log("catched error", e))
}

api.fetchTasks = async (query) => {
  const apiToken = localStorage.getItem('apiToken')
  return await axios.create({ baseURL: window.fmsApiLink }).post("task", query, {
    headers: { Authorization: `Bearer ${apiToken}` },
  }).catch(e => console.log("catched error", e))
}

api.fetchAreas = async (query) => {
  const apiToken = localStorage.getItem('apiToken')
  return await axios.create({ baseURL: window.fmsApiLink }).post("area", query, {
    headers: { Authorization: `Bearer ${apiToken}` },
  }).catch(e => console.log("catched error", e))
}

api.findUsed = async (query) => {
  const apiToken = localStorage.getItem('apiToken')
  console.log("Token ", apiToken)
  return await axios.create({ baseURL: window.fmsApiLink }).post("used", query, {
    headers: { Authorization: `Bearer ${apiToken}` },
  })
}

api.updateUsed = async (query, type) => {
  const apiToken = localStorage.getItem('apiToken')
  console.log(query, type)
  return await axios.create({ baseURL: window.fmsApiLink }).post("/used/update/" + type, query, {
    headers: { Authorization: `Bearer ${apiToken}` },
  })
}

api.deleteUsed = async (type) => {
  const apiToken = localStorage.getItem('apiToken')

  return await axios.create({ baseURL: window.fmsApiLink }).delete("/used/delete/" + type, {
    headers: { Authorization: `Bearer ${apiToken}` },
  })
}

api.fetchOperation = async (id) => {
  const apiToken = localStorage.getItem('apiToken')
  const res = await axios.create({ baseURL: window.fmsApiLink }).post("operations/fetch", { _id: id }, {
    headers: { Authorization: `Bearer ${apiToken}` }
  }).catch(e => console.log("caught error", e))
  return res
}

api.getOperations = async () => {
  const apiToken = localStorage.getItem('apiToken')
  // const query = { query: filters, limit: 10 }
  const res = await axios.create({ baseURL: window.fmsApiLink }).post("operations", {}, {
    headers: { Authorization: `Bearer ${apiToken}`, }
  }).catch(e => console.log("caught error", e))
  return res
}

api.fetchRacks = async () => {
  const apiToken = localStorage.getItem('apiToken')

  const res = await axios.create({ baseURL: window.fmsApiLink }).post("rack", {}, {
    headers: { Authorization: `Bearer ${apiToken}` }
  }).catch(e => console.log("caught error", e))
  return res
}

api.updateOccupation = async (rack, position, value) => {
  let apiToken
  if (localStorage.getItem("apiToken")[0] !== '"') apiToken = localStorage.getItem("apiToken")
  else apiToken = JSON.parse(localStorage.getItem('apiToken'))
  const res = await axios.create({ baseURL: window.fmsApiLink }).post("rack/occupation", { rack, position, value }, {
    headers: { Authorization: `Bearer ${apiToken}` }
  }).catch(e => console.log("caught error", e))
  return res
}

api.fetchPrisoners = async (robots) => {
  let apiToken
  if (localStorage.getItem("apiToken")[0] !== '"') apiToken = localStorage.getItem("apiToken")
  else apiToken = JSON.parse(localStorage.getItem('apiToken'))
  const res = await axios.create({ baseURL: window.fmsApiLink }).post("traffic/jailed", { robots }, {
    headers: { Authorization: `Bearer ${apiToken}` }
  }).catch(e => console.log("caught error", e))
  return res 
}

api.fetchBlocked = async (robots) => {
  let apiToken
  if (localStorage.getItem("apiToken")[0] !== '"') apiToken = localStorage.getItem("apiToken")
  else apiToken = JSON.parse(localStorage.getItem('apiToken'))
  const res = await axios.create({ baseURL: window.fmsApiLink }).post("blocks/active", { robots }, {
    headers: { Authorization: `Bearer ${apiToken}` }
  }).catch(e => console.log("caught error", e))
  return res 
}

api.fetchEmergencied = async (robots) => {
  let apiToken
  if (localStorage.getItem("apiToken")[0] !== '"') apiToken = localStorage.getItem("apiToken")
  else apiToken = JSON.parse(localStorage.getItem('apiToken'))
  const res = await axios.create({ baseURL: window.fmsApiLink }).post("emergency/active", { robots }, {
    headers: { Authorization: `Bearer ${apiToken}` }
  }).catch(e => console.log("caught error", e))
  return res 
}

/************************************ */